module.exports = __webpack_public_path__ + "static/media/share_green_gradient.d75065e8.png";